import { render, staticRenderFns } from "./PreviousYear.vue?vue&type=template&id=01025ddc&scoped=true&"
import script from "./PreviousYear.vue?vue&type=script&lang=js&"
export * from "./PreviousYear.vue?vue&type=script&lang=js&"
import style0 from "./PreviousYear.vue?vue&type=style&index=0&id=01025ddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01025ddc",
  null
  
)

export default component.exports